import { render, staticRenderFns } from "./agenda-info-modal.vue?vue&type=template&id=62f2217d&scoped=true&"
import script from "./agenda-info-modal.vue?vue&type=script&lang=js&"
export * from "./agenda-info-modal.vue?vue&type=script&lang=js&"
import style0 from "./agenda-info-modal.vue?vue&type=style&index=0&id=62f2217d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f2217d",
  null
  
)

export default component.exports